import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

export const FloatingHomeButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [showButton, setShowButton] = useState(false);
  
  // Show button when scrolled down
  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling down 300px
      setShowButton(window.scrollY > 300);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Don't show button at top of page
  if (!showButton) {
    return null;
  }
  
  // FIX 2: Always scroll to top of current page, never navigate away
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  const buttonStyle = {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    zIndex: 40,
    width: '56px',
    height: '56px',
    backgroundColor: isHovered ? '#C8A882' : '#5D4037',
    color: '#FAF9F6',
    borderRadius: '50%',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
    transition: 'all 0.3s ease',
    transform: isHovered ? 'scale(1.1)' : 'scale(1)',
    outline: 'none',
    pointerEvents: 'auto',
  };
  
  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={buttonStyle}
      aria-label="Scroll naar boven"
      title="Scroll naar boven"
      data-testid="scroll-to-top-btn"
    >
      <ArrowUp 
        style={{ 
          width: '24px', 
          height: '24px',
          transition: 'transform 0.3s ease',
          transform: isHovered ? 'scale(1.1)' : 'scale(1)'
        }} 
      />
    </button>
  );
};
